export default __webpack_public_path__ + "static/media/html.cfb2ba4a.png";